import { IEntity } from 'viggo-sistemas-core-web';

export interface ICategoriaMateriaPrima extends IEntity {
  codigo: number;
  descricao: string;
  domain_id: string;
  classificacao: CLASSIFICACAO_CATEGORIA | string;
}

export enum CLASSIFICACAO_CATEGORIA {
  TECIDO = 'TECIDO',
  ADICIONAL = 'ADICIONAL',
  ACABAMENTO = 'ACABAMENTO',
  OUTROS = 'OUTROS'
}
